import { Item } from "src/app/shared/fd-form-components/fd-select/fd-select.component";
import { TechnologyInformationDto } from "./technology-information-dto";

export class ParamRates {
  personType!: string;
  mccNumber?: number;
  cnae!: string;
  annualBillingValue!: number;
  idCampaign!: number | null;
  campaignCode?: string;
  uf!: string;
  receivingDeadline!: number | null;
  chargeModelEnum!: string | null;
  cpfCnpj!: string;
  automaticPrepayment!: boolean;
  offerMessage?: string;
  hasEconomicGroup!: boolean;
  institutionId!: string | null;
  serviceContract!: number | null;
  campaignName?: string;
  techReport!: Array<TechReportDTO> | null;
}

export class TechReportDTO{
  name!: string;
  value!: string;
  totalValue!: string;
  qtd!: number;
  serviceId!: string;
}

export class Phrases {
  exemptionPolicyPhraseFactorFlex!: string;
  phrase!: string;
  pricingTechnologyPhrase!: string;
  disclaimerPhrase!: string;
  disclaimerTechPhrase!: string;
  offerMessage!: string;
  cloverPhrase!: string;
}

export class CampaignSimulator extends Item {
  idCampaign!: number;
  campaignCode!: string;
  description!: string;
  hasMdrFlex!: boolean;
  hasMdr!: boolean;
  mdrWithPrepayment!: boolean;
  minAnnualBilling!: number;
  maxAnnualBilling!: number;
  hasNegotiation!: boolean;
  technologyList!: Array<TechnologyInformationDto>;
  amountTechs!: Array<number>;
}
